import { render, staticRenderFns } from "./HomeAtendente.vue?vue&type=template&id=24984b0b&scoped=true"
import script from "./HomeAtendente.vue?vue&type=script&lang=js"
export * from "./HomeAtendente.vue?vue&type=script&lang=js"
import style0 from "./HomeAtendente.vue?vue&type=style&index=0&id=24984b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24984b0b",
  null
  
)

export default component.exports